/* Map Stores by Country
 * Usado por: sections/map-stores-country.liquid
 *
 * - Carga las tiendas desde assets/stores-data.json (agrupadas por país ISO).
 * - Detecta el país vía data-country (localization.country.iso_code de Shopify Markets).
 *   Si el país detectado no tiene tiendas, usa data-default-country y muestra el selector.
 * - Renderiza listado de tiendas + mapa Google Maps con marcadores por país.
 *
 * Eventos dataLayer:
 *   stores_country_view  { country }
 *   store_select         { country, store_code, store_name }
 *   store_contact_click  { country, store_code, store_name, contact_type }
 */
(function () {
  'use strict';

  var DEFAULT_MARKER_ICON = 'https://cdn.shopify.com/s/files/1/0407/6155/7148/files/logo_cat-min.png';

  var ICONS = {
    phone: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/></svg>',
    whatsapp: '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M17.47 14.38c-.3-.15-1.76-.87-2.03-.97-.27-.1-.47-.15-.67.15-.2.3-.77.97-.94 1.17-.17.2-.35.22-.65.07-.3-.15-1.26-.46-2.4-1.48-.88-.79-1.48-1.76-1.65-2.06-.17-.3-.02-.46.13-.61.13-.13.3-.35.45-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.02-.52-.08-.15-.67-1.62-.92-2.22-.24-.58-.49-.5-.67-.51l-.57-.01c-.2 0-.52.07-.8.37-.27.3-1.04 1.02-1.04 2.5 0 1.47 1.07 2.89 1.22 3.09.15.2 2.11 3.22 5.1 4.51.71.31 1.27.49 1.7.63.72.23 1.37.2 1.88.12.57-.08 1.76-.72 2-1.41.25-.7.25-1.29.18-1.42-.08-.12-.28-.2-.58-.35zM12.05 21.79h-.01a9.8 9.8 0 0 1-4.98-1.36l-.36-.21-3.7.97.99-3.61-.24-.37a9.77 9.77 0 0 1-1.5-5.21c0-5.4 4.4-9.79 9.81-9.79a9.74 9.74 0 0 1 6.93 2.87 9.73 9.73 0 0 1 2.87 6.93c0 5.4-4.4 9.78-9.81 9.78zm8.35-18.13A11.7 11.7 0 0 0 12.05 .25C5.55.25.26 5.53.26 12.02c0 2.07.54 4.1 1.57 5.89L.16 23.83l6.07-1.59a11.79 11.79 0 0 0 5.81 1.48h.01c6.5 0 11.79-5.28 11.79-11.78 0-3.15-1.22-6.1-3.44-8.33z"/></svg>',
    waze: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polygon points="3 11 22 2 13 21 11 13 3 11"/></svg>',
    map: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg>',
    star: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>',
    share: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 5v10"/><path d="M8 9l4-4 4 4"/><path d="M5 15v4a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-4"/></svg>'
  };

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  /* El horario viene de nuestro propio JSON y puede incluir <br>; se permite solo esa etiqueta. */
  function sanitizeSchedule(value) {
    return escapeHtml(value).replace(/&lt;br\s*\/?&gt;/gi, '<br>');
  }

  function pushDataLayer(payload) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
  }

  function MapStoresCountry(root) {
    this.root = root;
    this.sectionId = root.dataset.sectionId;
    this.apiKey = root.dataset.apiKey || '';
    this.storesUrl = root.dataset.storesUrl;
    this.detectedCountry = (root.dataset.country || '').toUpperCase();
    this.defaultCountry = (root.dataset.defaultCountry || '').toUpperCase();
    this.showSelector = root.dataset.showSelector !== 'false';

    this.listEl = root.querySelector('[data-stores-list]');
    this.tabsEl = root.querySelector('[data-country-tabs]');
    this.mapEl = root.querySelector('[data-map]');
    this.searchEl = root.querySelector('[data-store-search]');

    this.data = null;
    this.activeCountry = null;
    this.map = null;
    this.markers = {};
    this.activeInfoWindow = null;

    this.init();
  }

  MapStoresCountry.prototype.init = function () {
    var self = this;

    fetch(this.storesUrl)
      .then(function (response) {
        if (!response.ok) throw new Error('No se pudo cargar stores-data.json (' + response.status + ')');
        return response.json();
      })
      .then(function (data) {
        self.data = data;
        self.activeCountry = self.resolveCountry();
        self.renderCountryTabs();
        self.renderStores();
        self.loadGoogleMaps();
        pushDataLayer({
          event: 'stores_country_view',
          country: self.activeCountry ? self.activeCountry.iso : ''
        });
      })
      .catch(function (error) {
        console.error('[map-stores-country]', error);
        if (self.listEl) {
          self.listEl.innerHTML = '<div class="no-stores"><p>No se pudieron cargar las tiendas. Intenta recargar la página.</p></div>';
        }
      });

    if (this.searchEl) {
      this.searchEl.addEventListener('input', function () {
        self.filterStores(self.searchEl.value);
      });
    }

    /* Delegación de clicks para analytics de contacto */
    this.root.addEventListener('click', function (event) {
      var link = event.target.closest('[data-analytics-event]');
      if (!link) return;
      pushDataLayer({
        event: link.dataset.analyticsEvent,
        country: self.activeCountry ? self.activeCountry.iso : '',
        store_code: link.dataset.storeCode || '',
        store_name: link.dataset.storeName || '',
        contact_type: link.dataset.contactType || ''
      });
    });
  };

  MapStoresCountry.prototype.getCountry = function (iso) {
    if (!this.data || !iso) return null;
    return this.data.countries.find(function (country) {
      return country.iso === iso && country.stores && country.stores.length > 0;
    }) || null;
  };

  /* Prioridad: país detectado por Shopify Markets → país por defecto → primer país con tiendas. */
  MapStoresCountry.prototype.resolveCountry = function () {
    return (
      this.getCountry(this.detectedCountry) ||
      this.getCountry(this.defaultCountry) ||
      this.data.countries.find(function (country) {
        return country.stores && country.stores.length > 0;
      }) ||
      null
    );
  };

  MapStoresCountry.prototype.renderCountryTabs = function () {
    if (!this.tabsEl) return;

    if (!this.showSelector) {
      this.tabsEl.hidden = true;
      return;
    }

    var self = this;
    this.tabsEl.hidden = false;
    this.tabsEl.innerHTML = '';

    this.data.countries.forEach(function (country) {
      if (!country.stores || country.stores.length === 0) return;
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'country-tab' + (self.activeCountry && self.activeCountry.iso === country.iso ? ' active' : '');
      button.textContent = country.name + ' (' + country.stores.length + ')';
      button.setAttribute('aria-pressed', self.activeCountry && self.activeCountry.iso === country.iso ? 'true' : 'false');
      button.addEventListener('click', function () {
        self.setCountry(country.iso);
      });
      self.tabsEl.appendChild(button);
    });
  };

  MapStoresCountry.prototype.setCountry = function (iso) {
    var country = this.getCountry(iso);
    if (!country || (this.activeCountry && this.activeCountry.iso === iso)) return;

    this.activeCountry = country;
    if (this.searchEl) this.searchEl.value = '';
    this.renderCountryTabs();
    this.renderStores();
    this.renderMarkers();
    pushDataLayer({ event: 'stores_country_view', country: country.iso });
  };

  MapStoresCountry.prototype.buildActions = function (store, dialCode) {
    var attrs = ' data-store-code="' + escapeHtml(store.code) + '" data-store-name="' + escapeHtml(store.name) + '"';
    var html = '<div class="store-actions">';

    if (store.phone) {
      html += '<a class="place-link" href="tel:+' + escapeHtml(dialCode + store.phone) + '"' + attrs +
        ' data-analytics-event="store_contact_click" data-contact-type="phone">' + ICONS.phone + ' Llamar</a>';
    }
    if (store.whatsapp) {
      html += '<a class="place-link whatsapp" target="_blank" rel="noopener" href="https://api.whatsapp.com/send?phone=' +
        escapeHtml(dialCode + store.whatsapp) + '"' + attrs +
        ' data-analytics-event="store_contact_click" data-contact-type="whatsapp">' + ICONS.whatsapp + ' WhatsApp</a>';
    }
    html += '<a class="place-link waze" target="_blank" rel="noopener" href="https://www.waze.com/ul?ll=' +
      store.lat + '%2C' + store.lng + '&navigate=yes&zoom=17"' + attrs +
      ' data-analytics-event="store_contact_click" data-contact-type="waze">' + ICONS.waze + ' Waze</a>';

    if (store.maps_link) {
      html += '<a class="place-link" target="_blank" rel="noopener" href="' + escapeHtml(store.maps_link) + '"' + attrs +
        ' data-analytics-event="store_contact_click" data-contact-type="google_maps">' + ICONS.map + ' Ver mapa</a>';
    }
    if (store.review_link) {
      html += '<a class="place-link primary" target="_blank" rel="noopener" href="' + escapeHtml(store.review_link) + '"' + attrs +
        ' data-analytics-event="store_contact_click" data-contact-type="review">' + ICONS.star + ' Reseña</a>';
    }
    html += '<button type="button" class="place-link" data-share' + attrs +
      ' data-analytics-event="store_contact_click" data-contact-type="share" aria-label="Compartir tienda ' +
      escapeHtml(store.name) + '">' + ICONS.share + ' Compartir</button>';

    html += '</div>';
    return html;
  };

  MapStoresCountry.prototype.renderStores = function () {
    if (!this.listEl) return;

    var self = this;
    var country = this.activeCountry;

    if (!country || !country.stores.length) {
      this.listEl.innerHTML = '<div class="no-stores"><p>No hay tiendas disponibles para este país.</p></div>';
      return;
    }

    var html = country.stores.map(function (store) {
      return (
        '<div class="contentDiv" role="button" tabindex="0"' +
        ' data-store-code="' + escapeHtml(store.code) + '"' +
        ' data-store-name="' + escapeHtml(store.name.toLowerCase()) + '"' +
        ' data-store-address="' + escapeHtml(store.address.toLowerCase()) + '"' +
        ' aria-label="Ver ' + escapeHtml(store.name) + ' en el mapa">' +
        '<div class="place-name">' + escapeHtml(store.name) + '</div>' +
        '<div class="place-general">' + escapeHtml(store.address) + '</div>' +
        '<div class="place-general place-general--schedule">' + sanitizeSchedule(store.schedule) + '</div>' +
        self.buildActions(store, country.dial_code) +
        '</div>'
      );
    }).join('');

    this.listEl.innerHTML = html;

    this.listEl.querySelectorAll('.contentDiv').forEach(function (card) {
      var select = function (event) {
        /* No seleccionar la tienda si el click fue sobre un enlace o botón de acción */
        if (event.target.closest('a, button')) return;
        self.selectStore(card.dataset.storeCode, true);
      };
      card.addEventListener('click', select);
      card.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          self.selectStore(card.dataset.storeCode, true);
        }
      });
    });

    this.listEl.querySelectorAll('[data-share]').forEach(function (button) {
      button.addEventListener('click', function () {
        self.shareStore(button.dataset.storeCode);
      });
    });
  };

  MapStoresCountry.prototype.findStore = function (code) {
    if (!this.activeCountry) return null;
    return this.activeCountry.stores.find(function (store) {
      return store.code === code;
    }) || null;
  };

  MapStoresCountry.prototype.selectStore = function (code, fromList) {
    var store = this.findStore(code);
    if (!store) return;

    this.listEl.querySelectorAll('.contentDiv').forEach(function (card) {
      card.classList.toggle('active', card.dataset.storeCode === code);
      if (card.dataset.storeCode === code && !fromList) {
        card.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
    });

    if (this.map) {
      this.map.setCenter({ lat: store.lat, lng: store.lng });
      this.map.setZoom(17);

      var markerObj = this.markers[code];
      if (markerObj) {
        if (this.activeInfoWindow) this.activeInfoWindow.close();
        markerObj.infowindow.open(this.map, markerObj.marker);
        this.activeInfoWindow = markerObj.infowindow;
      }

      if (fromList && window.innerWidth < 1024 && this.mapEl) {
        this.mapEl.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
    }

    pushDataLayer({
      event: 'store_select',
      country: this.activeCountry.iso,
      store_code: store.code,
      store_name: store.name
    });
  };

  MapStoresCountry.prototype.filterStores = function (searchText) {
    if (!this.listEl) return;
    var filter = (searchText || '').toLowerCase().trim();
    var found = 0;

    this.listEl.querySelectorAll('.contentDiv').forEach(function (card) {
      var matches =
        filter === '' ||
        (card.dataset.storeName || '').includes(filter) ||
        (card.dataset.storeAddress || '').includes(filter);
      card.style.display = matches ? 'block' : 'none';
      if (matches) found++;
    });

    var message = this.listEl.querySelector('.no-results-message');
    if (found === 0 && filter !== '') {
      if (!message) {
        message = document.createElement('div');
        message.className = 'no-results-message';
        message.innerHTML = '<p>🔍 No se encontraron tiendas</p><p>Intenta con otro término de búsqueda</p>';
        this.listEl.appendChild(message);
      }
    } else if (message) {
      message.remove();
    }
  };

  MapStoresCountry.prototype.shareStore = function (code) {
    var store = this.findStore(code);
    if (!store) return;

    var mapsUrl = 'https://www.google.com/maps/search/?api=1&query=' + store.lat + ',' + store.lng;
    var text = 'Mira esta tienda: ' + store.name + ' - ' + store.address;

    if (navigator.share) {
      navigator.share({ title: store.name, text: text, url: window.location.href }).catch(function () {});
    } else if (navigator.clipboard) {
      navigator.clipboard.writeText(text + '\n' + mapsUrl).then(function () {
        alert('Información de la tienda copiada al portapapeles.');
      });
    }
  };

  /* ---------- Google Maps ---------- */

  MapStoresCountry.prototype.loadGoogleMaps = function () {
    var self = this;

    if (!this.apiKey) {
      if (this.mapEl) {
        this.mapEl.innerHTML = '<div class="no-stores"><p>⚠️ API Key de Google Maps no configurada.</p></div>';
      }
      return;
    }

    if (window.google && window.google.maps) {
      this.initMap();
      return;
    }

    if (!window.googleMapsLoadingPromise) {
      window.googleMapsLoadingPromise = new Promise(function (resolve, reject) {
        var callbackName = 'initGoogleMapsCallback_' + self.sectionId.replace(/[^a-zA-Z0-9]/g, '_');
        window[callbackName] = function () {
          delete window[callbackName];
          resolve();
        };
        var script = document.createElement('script');
        script.src = 'https://maps.googleapis.com/maps/api/js?key=' + self.apiKey + '&callback=' + callbackName + '&v=beta';
        script.async = true;
        script.defer = true;
        script.onerror = function () {
          reject(new Error('Failed to load Google Maps'));
        };
        document.head.appendChild(script);
      });
    }

    window.googleMapsLoadingPromise
      .then(function () {
        self.initMap();
      })
      .catch(function () {
        if (self.mapEl) {
          self.mapEl.innerHTML = '<div class="no-stores"><p>❌ Error al cargar Google Maps. Verifica tu conexión y la API Key.</p></div>';
        }
      });
  };

  MapStoresCountry.prototype.initMap = function () {
    if (!this.mapEl || !this.activeCountry) return;

    var first = this.activeCountry.stores[0];
    this.mapEl.classList.remove('map-loading');
    this.mapEl.innerHTML = '';
    this.map = new google.maps.Map(this.mapEl, {
      zoom: 12,
      center: { lat: first ? first.lat : 0, lng: first ? first.lng : 0 },
      mapId: 'store-locations-map',
      gestureHandling: 'cooperative',
      zoomControl: true,
      mapTypeControl: false,
      streetViewControl: false,
      fullscreenControl: true
    });

    this.renderMarkers();
  };

  MapStoresCountry.prototype.clearMarkers = function () {
    var markers = this.markers;
    Object.keys(markers).forEach(function (code) {
      var marker = markers[code].marker;
      if (marker.setMap) {
        marker.setMap(null);
      } else {
        marker.map = null;
      }
    });
    this.markers = {};
    if (this.activeInfoWindow) {
      this.activeInfoWindow.close();
      this.activeInfoWindow = null;
    }
  };

  MapStoresCountry.prototype.renderMarkers = function () {
    if (!this.map || !this.activeCountry) return;

    var self = this;
    this.clearMarkers();

    var bounds = new google.maps.LatLngBounds();
    var useAdvanced = google.maps.marker && google.maps.marker.AdvancedMarkerElement;

    this.activeCountry.stores.forEach(function (store) {
      if (isNaN(store.lat) || isNaN(store.lng)) return;

      var position = { lat: store.lat, lng: store.lng };
      var marker;

      if (useAdvanced) {
        var icon = document.createElement('img');
        icon.src = DEFAULT_MARKER_ICON;
        icon.alt = '';
        icon.style.width = '48px';
        icon.style.height = '36px';
        marker = new google.maps.marker.AdvancedMarkerElement({
          position: position,
          map: self.map,
          title: store.name,
          content: icon
        });
      } else {
        marker = new google.maps.Marker({
          position: position,
          map: self.map,
          title: store.name,
          icon: { url: DEFAULT_MARKER_ICON, scaledSize: new google.maps.Size(48, 36) }
        });
      }

      var content =
        '<div style="padding:16px;max-width:320px;font-family:system-ui,-apple-system,sans-serif;">' +
        '<div style="font-weight:800;font-size:18px;margin-bottom:12px;color:#000;">' + escapeHtml(store.name) + '</div>' +
        '<div style="display:inline-block;background:#ffc400;color:#000;padding:4px 10px;border-radius:12px;font-size:11px;font-weight:800;margin-bottom:12px;">' + escapeHtml(store.code) + '</div>' +
        '<div style="margin:8px 0;color:#6c757d;line-height:1.6;">📍 ' + escapeHtml(store.address) + '</div>' +
        '<div style="margin:8px 0;color:#6c757d;line-height:1.6;">🕐 ' + sanitizeSchedule(store.schedule) + '</div>' +
        '</div>';

      var infowindow = new google.maps.InfoWindow({ content: content, maxWidth: 350 });

      marker.addListener('click', function () {
        self.selectStore(store.code, false);
      });

      self.markers[store.code] = { marker: marker, infowindow: infowindow };
      bounds.extend(position);
    });

    if (!bounds.isEmpty()) {
      if (this.activeCountry.stores.length === 1) {
        this.map.setCenter(bounds.getCenter());
        this.map.setZoom(15);
      } else {
        this.map.fitBounds(bounds, 48);
      }
    }
  };

  /* ---------- Inicialización ---------- */

  function initAll(scope) {
    (scope || document).querySelectorAll('.map-stores-country').forEach(function (root) {
      if (root.dataset.initialized) return;
      root.dataset.initialized = 'true';
      new MapStoresCountry(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  /* Soporte para Shopify Theme Editor (carga/descarga dinámica de secciones) */
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
